Vue.component('login', {
  template: templates.login,
  data() {
    return {
      model: {
        email: null,
        password: null,
        error: false
      }
    }
  },
  methods: {
    login() {
      const c = this;
      c.model.error = false;
      userService.login({
        email: c.model.email,
        password: c.model.password
      })
      .then(function (response) {
      console.log('Full response.data:', response.data);  // Log the entire object
       console.log('twitchId:', response.data.twitchId);   // Check each one
       console.log('theme:', response.data.theme);
        utils.cookies.set('user_id', response.data.twitchId);
        utils.cookies.set('user_login', response.data.twitchLogin);
        utils.cookies.set('user_display_name', response.data.twitchDisplayName);
        utils.cookies.set('user_email', response.data.twitchEmail);
        utils.cookies.set('user_profile_image', response.data.twitchProfileImage);
        utils.cookies.set('access_token', response.data.accessToken);
        utils.cookies.set('refresh_token', response.data.refreshToken);
        utils.cookies.set('user_role', response.data.role);
        utils.cookies.set('theme', response.data.theme);
        // window.location.href = 'dashboard';
      })
      .catch(function (error) {
        c.model.error = true;
      });
    }
  }
});

const vueApp = new Vue({
  el: '[data-view="login"]'
});
